import * as React from "react";
import { useNavigate, Link } from "@tanstack/react-router";
import { AmbientBackground } from "@/components/landing";
import { AuthCard, AuthDivider, SignupForm, GoogleButton } from "@/components/auth";
import { useAuth } from "@/hooks/useAuth";

export function SignupPage() {
  const navigate = useNavigate();
  const { signInWithGoogle, loading, user } = useAuth();

  React.useEffect(() => {
    if (user) {
      navigate({ to: "/dashboard" });
    }
  }, [user, navigate]);

  const handleSuccess = () => {
    // After signup, user needs to confirm email
    // Stay on page and show success message (handled by form)
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error("Google sign-in failed:", error);
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center p-4">
      <AmbientBackground />

      <AuthCard
        title="Create an account"
        description="Get started with your free account"
        footer={
          <>
            Already have an account?{" "}
            <Link to="/login" className="text-primary hover:underline font-medium">
              Sign in
            </Link>
          </>
        }
      >
        <GoogleButton onClick={handleGoogleSignIn} loading={loading} />
        <AuthDivider text="or continue with email" />
        <SignupForm onSuccess={handleSuccess} />
      </AuthCard>
    </div>
  );
}

export default SignupPage;
